import Vue from 'vue';
import Router from 'vue-router';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/',
            component: () => import('../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/home',
                    component: () => import('../components/pages/Home.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/order',
                    component: () => import('../components/pages/Order.vue'),
                    meta: { title: '订单管理' }
                },
                {
                    path: '/scenic',
                    component: () => import('../components/pages/Scenic.vue'),
                    meta: { title: '景点管理' }
                },
                {
                    path: '/food',
                    component: () => import('../components/pages/Food.vue'),
                    meta: { title: '美食管理' }
                },
                {
                    path: '/scenicmenu',
                    component: () => import('../components/pages/ScenicMenu.vue'),
                    meta: { title: '景点分类管理', permission: true }
                },
                {
                    path: '/ticket',
                    component: () => import('../components/pages/Ticket.vue'),
                    meta: { title: '门票管理' }
                },
                {
                    path: '/article',
                    component: () => import('../components/pages/Article.vue'),
                    meta: { title: '内容管理' }
                },
                {
                    path: '/hotelarea',
                    component: () => import('../components/pages/HotelArea.vue'),
                    meta: { title: '酒店区域管理', permission: true }
                },
                {
                    path: '/hotel',
                    component: () => import('../components/pages/Hotel.vue'),
                    meta: { title: '酒店管理' }
                },
                {
                    path: '/member',
                    component: () => import('../components/pages/Member.vue'),
                    meta: { title: '会员管理' }
                },
                {
                    path: '/memberset',
                    component: () => import('../components/pages/MemberSet.vue'),
                    meta: { title: '会员设置' }
                },
                {
                    path: '/mptool',
                    component: () => import('../components/pages/Mptool.vue'),
                    meta: { title: '微信素材管理' }
                },
                {
                    path: '/keywords',
                    component: () => import('../components/pages/Keywords.vue'),
                    meta: { title: '标签关键字' }
                },
                {
                    path: '/dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/icon',
                    component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/table',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/BaseTable.vue'),
                    meta: { title: '基础表格' }
                },
                {
                    path: '/tabs',
                    component: () => import(/* webpackChunkName: "tabs" */ '../components/page/Tabs.vue'),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: '/form',
                    component: () => import(/* webpackChunkName: "form" */ '../components/page/BaseForm.vue'),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: '/editor',
                    component: () => import(/* webpackChunkName: "editor" */ '../components/page/VueEditor.vue'),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: '/markdown',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Markdown.vue'),
                    meta: { title: 'markdown编辑器' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/Upload.vue'),
                    meta: { title: '文件上传' }
                },
                {
                    // vue-schart组件
                    path: '/charts',
                    component: () => import(/* webpackChunkName: "chart" */ '../components/page/BaseCharts.vue'),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: '/drag',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/DragList.vue'),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 拖拽Dialog组件
                    path: '/dialog',
                    component: () => import(/* webpackChunkName: "dragdialog" */ '../components/page/DragDialog.vue'),
                    meta: { title: '拖拽弹框' }
                },
                {
                    // 国际化组件
                    path: '/i18n',
                    component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
                    meta: { title: '国际化' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/donate',
                    component: () => import(/* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
                    meta: { title: '支持作者' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/pages/Login.vue'),
            meta: { title: '友朋旅游同业联盟' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
